import { useContext, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { ROLES } from "../constants/roles";

export const PublicRoutes = () => {
  const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
  const token = localStorage.getItem("token");

  if (user && token) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};
export const ProtectedRoutes = ({ role = [] }) => {
  const navigate = useNavigate();
  const { role: roleUser } = useContext(AuthContext);
  const { pathname } = useLocation();
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const [token, setToken] = useState(() => {
    return localStorage.getItem("token") || null;
  });

  const checkAuth = () => {
    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");

    const isRoleMismatch = role && !role.includes(roleUser);

    if (!storedUser || !storedToken) {
      setUser(null);
      setToken(null);
      navigate("/SignIn");
    } else if (pathname == "/" && roleUser == ROLES.STAFF) {
      navigate("/Tasks");
    } else if (isRoleMismatch) {
      navigate("/");
    }
  };

  useEffect(() => {
    const interval = setInterval(checkAuth, 500);
    return () => clearInterval(interval);
  }, [navigate, roleUser, role]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "user" || event.key === "token") {
        const newUser = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
        const newToken = localStorage.getItem("token");
        if (!newUser || !newToken) {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          setUser(null);
          setToken(null);
          navigate("/SignIn");
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [navigate]);

  if (!user || !token) {
    return null;
  }

  return <Outlet />;
};
